<template>
  <div
    :class="'main-share ' + (absolute ? 'white pl-4 pr-6 pt-1' : '')"
    :style="color ? 'justify-content: left; margin: 0;' : ''"
  >
    <b
      v-if="!absolute"
      :style="color ? 'color: ' + color + ';' : ''"
    >
      {{ $i18n.t('jaga') }}:
    </b>
    <a
      :style="color ? 'color: ' + color + ';' : ''"
      :href="
        'http://twitter.com/share?text=Costasolrent.com - &amp;url=' + siteLink
      "
      class="twitter popup"
      target="_blank"
    >
      <i class="fab fa-twitter-square"></i>
    </a>
    <a
      :style="color ? 'color: ' + color + ';' : ''"
      :href="'http://www.facebook.com/share.php?u=' + siteLink"
      class="facebook popup"
      target="_blank"
    >
      <i class="fab fa-facebook-square"></i>
    </a>
    <a
      :style="color ? 'color: ' + color + ';' : ''"
      :href="'https://plus.google.com/share?url=' + siteLink"
      class="google popup"
      target="_blank"
    >
      <i class="fab fa-google-plus-square"></i>
    </a>
    <a
      :style="color ? 'color: ' + color + ';' : ''"
      :href="
        'https://www.linkedin.com/shareArticle?mini=true&amp;url=' + siteLink
      "
      class="popup"
      target="_blank"
    >
      <i class="fab fa-linkedin"></i>
    </a>
    <a
      :style="color ? 'color: ' + color + ';' : ''"
      :href="'whatsapp://send?text=' + siteLink"
      class="popup"
      target="_blank"
    >
      <i class="fab fa-whatsapp-square"></i>
    </a>
    <a
      v-if="!color"
      :style="color ? 'color: ' + color + ';' : ''"
      href="javascript:void(0)"
      class="share-email-option"
      @click="showEmailModal = true"
    >
      <i class="fas fa-envelope-square"></i>
    </a>
  </div>
</template>

<script>
import { createHelpers } from 'vuex-map-fields'
import state from '../../../store/state.js'
const { mapFields } = createHelpers({
  getterType: 'getField',
  mutationType: 'updateField',
})

export default {
  name: 'MainShare',

  props: {
    color: {
      type: String,
      default: null,
    },
    absolute: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    ...mapFields(Object.keys(state)),

    siteLink() {
      return window.location.origin + this.$route.fullPath
    },
  },
}
</script>

<style>
img.share-logo {
  vertical-align: middle;
  margin-left: 4px;
}
.main-share {
  color: gray;
  height: 40px;
  margin: 10px 0 10px 0;
  width: 100%;
  line-height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.main-share-absolute {
  position: absolute;
  top: -8px;
  right: 0;
  margin: 0 10px 0 0;
  width: auto;
}
.main-share a {
  padding: 5px 0 5px 9px;
  font-size: 26px;
}
.app-sidebar .main-share a,
.object-info .main-share a,
.v-menu__content .main-share a {
  color: grey !important;
}
</style>
